import { NavLink } from 'react-router-dom';
import { Home, Users, Dumbbell, Trophy, Menu, BarChart3 } from 'lucide-react';
import { cn } from '@/lib/utils';

const coachTabs = [
    { to: '/coach', icon: Home, label: 'Home', end: true },
    { to: '/coach/atleti', icon: Users, label: 'Atleti' },
    { to: '/coach/allenamenti', icon: Dumbbell, label: 'Allenam.' },
    { to: '/coach/gare', icon: Trophy, label: 'Gare' },
    { to: '/coach/altro', icon: Menu, label: 'Altro' }
];

const atletaTabs = [
    { to: '/atleta', icon: Home, label: 'Home', end: true },
    { to: '/atleta/allenamenti', icon: Dumbbell, label: 'Allenam.' },
    { to: '/atleta/gare', icon: Trophy, label: 'Gare' },
    { to: '/atleta/analisi', icon: BarChart3, label: 'Analisi' },
    { to: '/atleta/altro', icon: Menu, label: 'Altro' }
];

export function BottomNav({ role }: { role: 'coach' | 'atleta' }) {
    const tabs = role === 'coach' ? coachTabs : atletaTabs;
    return (
        <nav className="sticky bottom-0 z-30 bg-zinc-950/95 backdrop-blur border-t border-zinc-800 pb-[env(safe-area-inset-bottom)]">
            <div className="grid grid-cols-5 min-h-[56px]">
                {tabs.map(t => (
                    <NavLink
                        key={t.to}
                        to={t.to}
                        end={t.end}
                        className={({ isActive }) =>
                            cn(
                                'flex flex-col items-center justify-center gap-0.5 text-[11px] font-medium transition-colors min-h-[44px] min-w-[44px] active:scale-95',
                                isActive ? 'text-blue-400' : 'text-zinc-500 hover:text-zinc-300'
                            )
                        }
                    >
                        <t.icon className="w-5 h-5" />
                        <span>{t.label}</span>
                    </NavLink>
                ))}
            </div>
        </nav>
    );
}
